export const initGTM = () => {
  setDataLayer()
}

const setDataLayer = () => {
  window.dataLayer = [{
    LoggedIn: true,
    Product: 'NA',
    ServiceID: 'NA',
    Type: 'Checkout Flow',
    TabletAmount: 'NA',
    PrescriptionDuration: 'NA'
  }]
}

export const updateDataLayer = data => {
  window.dataLayer.push(data)
}

export const populateServiceDetails = assessmentContext => {
  const { service } = assessmentContext
  const serviceData = {
    ServiceID: service.id,
    servicePrice: (service.price / 100),
    Type: service.internal_name,
    event: 'PopulateService'
  }
  window.dataLayer.push(serviceData)
}

export const populateTransactionDetails = assessmentContext => {
  // eslint-disable-next-line camelcase
  const { service, order, selected_product, order_summary, returning_customer: returningCustomer } = assessmentContext
  const transactionData = {
    transactionId: order.id,
    transactionShipping: (order.delivery_price / 100),
    transactionTotal: (order.total_price / 100),
    transactionProducts: [{
      sku: selected_product.id,
      name: selected_product.name,
      category: service.internal_name,
      // Converting pence to pounds.
      price: (selected_product.price / 100),
      quantity: 1,
      delivery_mode: order_summary.delivery_mode_name
    }],
    transactionAffiliation: 'NA',
    event: 'PopulateTransaction',
    newUserRegistration: (returningCustomer ? 0 : 1)
  }
  window.dataLayer.push(transactionData)
}

export const pushSuccessRevenue = ({ orderId, revenue, patientId }) => {
  window.dataLayer.push({
    screen: 'checkout_success',
    orderId,
    revenue: (revenue / 100),
    patientId
  })
}

export const populateGTMInitial = () => {
  // eslint-disable-next-line camelcase
  const { service, order, selected_product } = window.serviceDetails
  window.dataLayer.push({
    LoggedIn: true,
    Product: selected_product.full_name,
    servicePrice: (service.price / 100),
    PatientID: order.patient_id,
    ServiceID: service.id,
    TabletAmount: selected_product.package_size,
    PrescriptionDuration: selected_product.reminder_message_after_days,
    Type: 'Checkout Flow'
  })
}
